<template>
    <div class="table-container">
      <div style="margin: 10px 0">
        <el-input style="width: 200px;" type="text" v-model="name" placeholder="请输入设备名称" suffix-icon="el-icon-search"></el-input>
        <!-- 超级管理员可以选择公司筛选 -->
        <el-select v-if="user.role === '超级管理员' || user.role === '管理员'" v-model="companyId" @change="onCompanyFilterChange" clearable placeholder="请选择公司" style="width: 200px; margin-left: 10px;">
          <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
        </el-select>
        <!-- 大棚筛选（根据所选公司动态切换） -->
        <el-select v-if="user.role === '超级管理员' || user.role === '管理员'" v-model="greenhouseId" @change="load" clearable placeholder="请选择大棚" style="width: 200px; margin-left: 10px;">
          <el-option v-for="greenhouse in availableGreenhouses" :key="greenhouse.id" :label="greenhouse.name" :value="greenhouse.id"></el-option>
        </el-select>
        <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>

        <el-button style="float:right; margin-left: 10px" type="danger" @click = "deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button>
        <el-button style="float:right;" type="primary" @click = "handAdd" icon="el-icon-circle-plus-outline">新增</el-button>
      </div>
      <!-- eslint-disable-next-line -->
      <el-table :data="tableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange" style="width:100%" :fit="true">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="name" label="设备名称" width="150">
        </el-table-column>
        <el-table-column prop="deviceSerial" label="序列号" width="180">
        </el-table-column>
        <el-table-column prop="channel" label="通道号" width="80">
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '在线' : '离线' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="companyId" label="公司" width="150">
          <template slot-scope="scope">
            {{ getCompanyName(scope.row.companyId) }}
          </template>
        </el-table-column>
        <el-table-column prop="greenhouseId" label="大棚" width="150">
          <template slot-scope="scope">
            {{ getGreenhouseName(scope.row.greenhouseId) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime ? new Date(scope.row.createTime).toLocaleString() : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.updateTime ? new Date(scope.row.updateTime).toLocaleString() : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" :min-width="150" align="center">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <!-- scope 拿到数据-->
            <el-button type="success" @click = "handEdit(scope.row)" style="margin-right: 5px">编辑<i class="el-icon-edit"></i></el-button>
            <el-popover
            placement="top"
            width="160"
            trigger="click">
            <p>您确定要删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible=false">取消</el-button>
              <el-button type="primary" size="mini" @click=handdele(scope.row.id)>确定</el-button>
            </div>
              <el-button type="danger" slot="reference">删除</el-button>
            </el-popover>

          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="录像设备信息" :visible.sync="dialogFormVisible" width="50%" >
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="设备名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="设备序列号" prop="deviceSerial">
            <el-input v-model="form.deviceSerial" placeholder="请输入萤石云设备序列号"></el-input>
          </el-form-item>
          <el-form-item label="通道号" prop="channel">
            <el-input-number v-model.number="form.channel" :min="1" :max="64" :precision="0" controls-position="right" placeholder="默认4"></el-input-number>
          </el-form-item>
          <el-form-item label="所属公司" prop="companyId">
            <!-- 超级管理员可以选择任何公司 -->
            <el-select v-if="user.role === '超级管理员'" v-model="form.companyId" placeholder="请选择公司" style="width: 100%;">
              <el-option v-for="company in companies" :key="company.id" :label="company.name" :value="company.id"></el-option>
            </el-select>
            <!-- 普通管理员只能看到自己的公司且不可修改 -->
            <el-input v-else :value="getCompanyName(user.companyid)" readonly placeholder="所属公司"></el-input>
          </el-form-item>
          <el-form-item label="所属大棚" prop="greenhouseId">
            <el-select v-model="form.greenhouseId" placeholder="请选择大棚" style="width: 100%;" filterable>
              <el-option v-for="greenhouse in availableGreenhouses" :key="greenhouse.id" :label="greenhouse.name" :value="greenhouse.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">确定</el-button>
            <el-button @click ='shutDown'>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    </template>

    <script>
    export default {
      name: "EzvizDevice",
      data () {
        return{
          tableData: [],
          name: '',
          companyId: null,
          greenhouseId: null,
          pageNum: 1,
          pageSize: 10,
          total: 0,
          dialogFormVisible: false,
          form: {},
          multipleSelection: {},
          headerBg: 'headerBg',
          data: {},
          visible: true,
          user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
          companies: [],
          greenhouses: [],
          availableGreenhouses: [], // 当前选中公司的可用大棚
          rules: {
            name: [
              { required: true, message: '请输入设备名称', trigger: 'blur' }
            ],
            deviceSerial: [
              { required: true, message: '请输入设备序列号', trigger: 'blur' },
              { pattern: /^[A-Za-z0-9]+$/, message: '序列号只能包含字母和数字', trigger: 'blur' }
            ],
            channel: [
              { required: true, message: '请输入通道号', trigger: 'blur' },
              { type: 'number', min: 1, max: 64, message: '通道号必须在1-64之间', trigger: 'blur' }
            ],
            companyId: [
              { required: true, message: '请选择所属公司', trigger: 'change' }
            ],
            greenhouseId: [
              { required: true, message: '请选择所属大棚', trigger: 'change' }
            ]
          }
        }
      },
      mounted () {
        // 检查权限：只有管理员和超级管理员可以访问录像设备管理
        if (this.user.role !== '管理员' && this.user.role !== '超级管理员') {
          this.$message.error('无权限访问录像设备管理功能')
          this.$router.push('/backhome')
          return
        }

        // 先获取公司和数据，再加载设备数据
        this.getCompanies().then(() => {
          this.load()
          // 同步加载所有大棚列表，用于表格中根据 greenhouseId 显示名称
          this.loadAllGreenhouses()
        })
      },
      watch: {
        // 监听对话框内公司选择变化，更新可用大棚列表
        'form.companyId': function(newVal) {
          if (newVal) {
            this.loadGreenhousesByCompany(newVal)
          } else {
            this.availableGreenhouses = []
          }
        },
        // 监听顶部公司筛选变化，动态切换顶部大棚下拉选项
        companyId: function(newVal) {
          if (newVal) {
            this.loadGreenhousesByCompany(newVal)
          } else {
            // 如果未选择公司，清空顶部大棚选项（超级管理员可见所有，普通管理员会在 mounted 加载）
            this.availableGreenhouses = []
          }
        },
        // 当顶部大棚选择变化时自动刷新列表（与 @change 绑定是冗余保护）
        greenhouseId: function() {
          this.load()
        }
      },
      methods: {
        load () {//点击页码进行get请求
          this.request.get('/api/ezviz-devices/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              name: this.name,
              companyId: this.companyId,
              greenhouseId: this.greenhouseId
            }
          }).then(res => {
            console.log('API响应:', res)
            if (res && res.data) {
              this.tableData = res.data.records || []
              this.total = res.data.total || 0
            } else {
              this.tableData = []
              this.total = 0
            }
          }).catch(error => {
            console.error('API调用失败:', error)
            this.tableData = []
            this.total = 0
            if (error.response && error.response.status === 403) {
              this.$message.error('无权限访问录像设备管理功能')
              this.$router.push('/backhome')
            }
          })
        },
        save () { // 新增或更新
          this.$refs.form.validate((valid) => {
            if (!valid) return

            this.request.post('/api/ezviz-devices/', this.form).then(res => {
              if (res && res.code === "200") {
                this.$message.success('保存成功')
                this.dialogFormVisible = false
                this.load()
              } else {
                this.$message.error('保存失败')
              }
            }).catch(error => {
              console.error('保存出错:', error)
              this.$message.error('保存失败，请重试')
              if (error.response && error.response.status === 403) {
                this.$message.error('无权限操作录像设备数据')
                this.$router.push('/backhome')
              }
            })
          })
        },
        handAdd () {
          this.dialogFormVisible = true //打开表单
          this.form = {
            channel: 4, // 默认通道号
            status: 0   // 默认离线状态
          }
          // 普通管理员自动设置公司ID
          if (this.user.role !== '超级管理员') {
            this.form.companyId = this.user.companyid
            // 加载该公司的可用大棚
            this.loadGreenhousesByCompany(this.user.companyid)
          }
        },
        handEdit (row) { //把row里的数据传给表单
          this.form = JSON.parse(JSON.stringify(row)) // 深拷贝
          this.dialogFormVisible = true
          // 编辑时也需要加载可用大棚列表
          if (this.form.companyId) {
            this.loadGreenhousesByCompany(this.form.companyId)
          }
        },
        handdele (id) { //通过id删除
          this.request.delete('/api/ezviz-devices/' + id).then(res => {
            if (res && res.code === "200") {
              this.$message.success('删除成功')
              this.load()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }).catch(error => {
            console.error('删除出错:', error)
            this.$message.error('删除失败，请重试')
            if (error.response && error.response.status === 403) {
              this.$message.error('无权限删除录像设备数据')
              this.$router.push('/backhome')
            }
          })
        },
        handleSelectionChange (val) {
          console.log(val)
          this.multipleSelection = val
        },
        deleteBatch () {
          if (this.multipleSelection.length === 0) {
            this.$message.warning('请选择要删除的录像设备')
            return
          }

          // eslint-disable-next-line
          let ids = this.multipleSelection.map(val => val.id)
          this.request.delete('/api/ezviz-devices/del/batch', { data: ids }).then(res => {
            if (res && res.code === "200") {
              this.$message.success('批量删除成功')
              this.load()
            } else {
              this.$message.error(res.message || '批量删除失败')
            }
          }).catch(error => {
            console.error('批量删除出错:', error)
            this.$message.error('批量删除失败，请重试')
            if (error.response && error.response.status === 403) {
              this.$message.error('无权限批量删除录像设备数据')
              this.$router.push('/backhome')
            }
          })
        },
        shutDown () {
          this.dialogFormVisible = false
          this.availableGreenhouses = [] // 清空可用大棚列表
        },
        getCompanies () {
          return this.request.get('/api/companies/').then(res => {
            if(res.code === "200"){
              this.companies = res.data.map(item => {
                return {
                  id: item.id,
                  name: item.name
                }
              })
              console.log('加载公司数据:', this.companies)
            }else{
              console.log('获取公司数据失败:', res.code, res.data);
              this.companies = []
            }
          }).catch(error => {
            console.error('获取公司数据出错:', error)
            this.companies = []
          })
        },
        loadGreenhousesByCompany (companyId) {
          // 根据公司ID加载大棚列表，使用后端 /greenhouses/list 接口确保按公司过滤
          this.request.get('/api/greenhouses/list', {
            params: { companyId: companyId }
          }).then(res => {
            console.log('GET /greenhouses/list response:', res)
            if (res && (res.code === "200" || Array.isArray(res))) {
              // 支持两种返回格式：Result包装或直接数组
              const data = res.code === "200" ? res.data : res
              this.availableGreenhouses = data || []
            } else {
              this.availableGreenhouses = []
            }
          }).catch(error => {
            console.error('获取大棚数据出错:', error)
            this.availableGreenhouses = []
          })
        },
        onCompanyFilterChange() {
          // 清空大棚选择并重新加载可用大棚
          this.greenhouseId = null
          if (this.companyId) {
            this.loadGreenhousesByCompany(this.companyId)
          } else {
            this.availableGreenhouses = []
          }
        },
        loadAllGreenhouses () {
          // 加载所有大棚（用于名称映射），并根据用户角色做过滤
          this.request.get('/api/greenhouses/').then(res => {
            console.log('GET /greenhouses/ response:', res)
            if (res && res.code === "200") {
              this.greenhouses = res.data || []
              // 非超级管理员只显示自己公司的大棚（用于名称映射和顶部筛选）
              if (this.user.role !== '超级管理员') {
                const userCompanyId = this.user.companyid
                this.greenhouses = this.greenhouses.filter(gh => gh.companyid === userCompanyId)
              }
            } else {
              console.warn('GET /greenhouses/ 非200响应，尝试回退接口 /greenhouses/test', res)
              // 回退：尝试调用测试接口以便调试或在权限/鉴权问题时仍能显示数据
              return this.request.get('/api/greenhouses/test')
            }
          }).then(fallbackRes => {
            if (fallbackRes && fallbackRes.code === "200") {
              console.log('GET /greenhouses/test fallback response:', fallbackRes)
              this.greenhouses = fallbackRes.data || []
              if (this.user.role !== '超级管理员') {
                const userCompanyId = this.user.companyid
                this.greenhouses = this.greenhouses.filter(gh => gh.companyid === userCompanyId)
              }
            }
          }).catch(error => {
            console.error('加载全部大棚失败（主接口或回退接口）：', error)
            this.greenhouses = []
          })
        },
        getCompanyName(companyId) {
          const company = this.companies.find(c => c.id === companyId)
          return company ? company.name : '未知公司'
        },
        getGreenhouseName(greenhouseId) {
          const greenhouse = this.greenhouses.find(g => g.id === greenhouseId)
          return greenhouse ? greenhouse.name : '未知大棚'
        },
        handleSizeChange (pageSize) {
          this.pageSize = pageSize
          this.load()
        },
        handleCurrentChange (pageNum) {
          this.pageNum = pageNum
          this.load()
        }
      }
    }
    </script>

    <style scoped>
    .table-container {
      width: 100%;
    }
    .table-container .el-table {
      width: 100%;
    }

    </style>
